import { ref, type Ref } from 'vue'
import { useApiKeyStore } from './useApiKeyStore'
import { listApiKeys } from '@/backend/darwin/listApiKeys'

export const useApiKeyLoader = (): { load: () => Promise<void>; loading: Ref<boolean> } => {
  const keyStore = useApiKeyStore()

  const loading = ref(false)
  const load = async (): Promise<void> => {
    if (loading.value) {
      return
    }
    loading.value = true

    const result = await listApiKeys()
    if (result.ok) {
      keyStore.apiKeys = result.data
    }
    loading.value = false
  }

  return { load, loading }
}
